/* MoRetro Studio - Liaison automatique devis provisoire -> commande Shopify payee. */
window.MTS = window.MTS || {};

(function(MTS){
  "use strict";
  const linked = new Set();

  function paid(order = {}){
    return ["PAID", "PARTIALLY_PAID"].includes(String(order.financialStatus || "").toUpperCase());
  }

  function pickupData(order = {}){
    const point = order.pickupPoint || {};
    return {
      deliveryMode: order.deliveryMode || "",
      pickupPoint: {
        id: point.id || "",
        name: point.name || "",
        address: point.address || "",
        carrier: point.carrier || ""
      }
    };
  }

  async function linkOrder(order){
    const projectId = String(order.studioProjectId || "").trim();
    if(!projectId || !paid(order) || linked.has(order.id)) return;
    const project = (MTS.state?.projects || []).find(item=>String(item.id) === projectId);
    if(!project || !MTS.state?.db) return;
    linked.add(order.id);
    const delivery = pickupData(order);
    const update = {
      status: "paid",
      shopifyOrderId: order.id || "",
      shopifyOrderLegacyId: order.legacyResourceId || "",
      shopifyOrderName: order.name || "",
      shopifyFinancialStatus: order.financialStatus || "",
      shopifyFulfillmentStatus: order.fulfillmentStatus || "",
      deliveryMode: delivery.deliveryMode,
      pickupPoint: delivery.pickupPoint,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp()
    };
    try{
      await MTS.state.db.collection("custom_requests").doc(projectId).set(update, {merge:true});
      Object.assign(project, update, {updatedAt:new Date().toISOString()});
      MTS.Projects?.renderList?.();
      MTS.Projects?.renderDetail?.(project);
    }catch(error){
      linked.delete(order.id);
      console.warn("Liaison commande Shopify impossible :", error.message);
    }
  }

  function renderPickup(){
    const detail = document.getElementById("mtsShopOrderDetail");
    const order = (MTS.state?.orders || []).find(item=>item.id === MTS.state?.selectedOrderId);
    if(!detail || !order) return;
    let box = document.getElementById("mtsOrderPickupInfo");
    const point = order.pickupPoint || {};
    if(!order.deliveryMode && !point.name){ box?.remove(); return; }
    if(!box){
      box = document.createElement("div");
      box.id = "mtsOrderPickupInfo";
      box.className = "mts-detail-message";
      detail.appendChild(box);
    }
    const text = [point.name, point.address, point.id ? `ID : ${point.id}` : ""].filter(Boolean).join(" — ");
    const html = `<span>📍 Livraison choisie</span><p><b>${MTS.escapeHtml(order.deliveryMode || "Point relais")}</b>${text ? `<br>${MTS.escapeHtml(text)}` : ""}</p>`;
    if(box.innerHTML !== html) box.innerHTML = html;
  }

  function sync(){
    (MTS.state?.orders || []).forEach(order=>linkOrder(order));
    renderPickup();
  }

  // Empêche la création d'une deuxième production pour une commande déjà liée au devis.
  document.addEventListener("click", event=>{
    const button = event.target.closest?.("#mtsCreateOrderProduction");
    if(!button) return;
    const order = (MTS.state?.orders || []).find(item=>item.id === MTS.state?.selectedOrderId);
    const projectId = String(order?.studioProjectId || "").trim();
    const project = (MTS.state?.projects || []).find(item=>String(item.id) === projectId);
    if(!project) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    MTS.state.selectedProjectId = projectId;
    document.querySelector('.mts-nav button[data-panel="projects"]')?.click();
    MTS.Projects?.renderList?.();
  }, true);

  function start(){
    if(MTS.shopifyOrderLinkTimer) return;
    sync();
    MTS.shopifyOrderLinkTimer = window.setInterval(sync, 2000);
  }
  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", ()=>setTimeout(start, 1800));
  else setTimeout(start, 1800);
  MTS.ShopifyOrderLink = {sync, start};
})(window.MTS);
